import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, retry, skip } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class ApiserviceService {
  private userdata: any;
  private userdatta: any;
  public demodata: Observable<Object> | undefined;
  private header: any;
  private fileheader: any;
  constructor(private http: HttpClient, private router: Router) {
    if (typeof sessionStorage !== 'undefined') {
      this.userdata = JSON.parse(`${typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('user') : undefined}`);
      this.userdatta = this.userdata;
      this.header = {
        'token': this.userdatta?.data.token,
        'content-type': 'application/json'
      };
      this.fileheader = {
        'token': this.userdatta?.data.token
      };
    } else {
      console.warn('sessionStorage is not available in this environment');
      this.userdata = null;
      this.userdatta = null;
      this.header = null;
    }
  }
  private clientstoview:any = new BehaviorSubject('');
  getclientstoview = this.clientstoview.asObservable();

  setclientstoview(data:any){
    this.clientstoview.next(data);
  }

  getcoursewisesemester(eventdata: any): Observable<any> {
    return this.http.get<any>(`${environment.API_URL}` + 'semisters?type=list&limit=100&course_id=' + eventdata.course_ID, { headers: this.header }).pipe(
      map(data => {
        return data
      }),
      catchError(this.handleError))
  }

  getloggerdata(date: any) {
    let body = date
    return this.http.post(`${environment.API_URL}` + 'employees/getlogger', body, { headers: this.header }).pipe(
      map(data => {
        return data
      }),
      catchError(this.handleError))
  }

  getaddresstoken(){
    let body = {
      "client_id": environment.CLIENT_ID,
      "client_secret": environment.CLIENT_SECRET}
      return this.http.post(`${environment.GEOSERVICE_API}` + 'geoservice/token', body).pipe(
        map(data => {
          return data
        }),
        catchError(this.handleError))
  }


  handleError(errorResponse: HttpErrorResponse) {
    if (errorResponse.status === 401 || errorResponse.status === 403) {
      sessionStorage.removeItem("user");
      window.location.reload();
      // this.AuthenticationService.logout();
    }
    return throwError(errorResponse.message || 'Server error');
  }

  private dismissError(): void {
    setTimeout(() => {
      // this.toast.dismissToast();
    }, 3000);
  }

}
